import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

export async function createLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function adminListLeads(token) {
  const { data } = await api.get("/admin/leads", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function adminUpdateLead(token, id, status) {
  const { data } = await api.patch(
    `/admin/leads/${id}`,
    { status },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}
